export const NOOP = function () {}
